export default function() {
    return {
        croppingImage: {},
        showCropper: false,
        user: {
            photo: null,
            photo_images: []
        },
        error: null,
        showErrorDialog: false,
    }
}
